import axios from 'axios';

// API endpoints 
// In development: lokale proxy of directe API calls
// In productie: Cloudflare Worker proxy
const DIRECT_API = process.env.REACT_APP_API_URL || 'https://api.andi-printsolutions.com';
const DEFAULT_API_TOKEN = process.env.REACT_APP_API_TOKEN || '';
const CLOUDFLARE_PROXY = process.env.REACT_APP_PROXY_URL || 'https://planning-app.qustom.workers.dev/api';
 
// Gebruik van proxy voor API calls 
// De direct URL, de token, en proxy URL kunnen in .env worden gezet
const useProxy = process.env.REACT_APP_USE_PROXY === 'true';

/**
 * Haalt de token uit de URL parameters
 * @returns {string} De token uit URL parameters of default token
 */
const getTokenFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('token') || DEFAULT_API_TOKEN;
};

/**
 * Bepaal welke API URL te gebruiken
 * @param {string} endpoint - De API endpoint zonder voorloopende '/'
 * @returns {string} De volledige API URL
 */
const getApiUrl = (endpoint) => {
  // Haal token uit URL parameters
  const tokenFromUrl = getTokenFromUrl();
  
  // Voeg token toe aan alle API calls
  const tokenParam = `${endpoint.includes('?') ? '&' : '?'}token=${tokenFromUrl}`;
  
  if (useProxy) {
    if (process.env.NODE_ENV === 'development') {
      // Development met proxy
      return `/api/${endpoint}${tokenParam}`;
    } else {
      // Productie met Cloudflare proxy
      return `${CLOUDFLARE_PROXY}/${endpoint}${tokenParam}`;
    }
  } else {
    // Directe API calls (voeg token toe)
    return `${DIRECT_API}/${endpoint}${tokenParam}`;
  }
};

/**
 * Haalt plangroepen op voor een conneoId
 */
export const getGroups = async (conneoId) => {
  try {
    const response = await axios.get(
      getApiUrl('planning/groups')
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching planning groups:', error);
    throw error;
  }
};

/**
 * Haalt planplaatsen op voor een groep
 */
export const getPlanPlaceDates = async (groupId) => {
  try {
    const response = await axios.get(
      getApiUrl(`planning/planplacedates?group=${groupId}`)
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching plan place dates:', error);
    throw error;
  }
};

/**
 * Haalt een plankaartje op voor een planItem
 */
export const getPlanCard = async (planItemId) => {
  try {
    const response = await axios.get(
      getApiUrl(`planning/plancard?objectid=${planItemId}`)
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching plan card:', error);
    throw error;
  }
};